module.exports = __webpack_public_path__ + "static/fonts/notokr-bold.84cf469.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/affiliatecard/font/notokr-bold.woff
// module id = ttr9
// module chunks = 0